import { IGptConfigDataResponse } from '@shared/models/proto/base/gpt'
import {
  IMessage,
  IMessagePayloadBotPayload,
} from '@shared/models/proto/base/messages'

export const getBotPayload = (
  message: IMessage
): IMessagePayloadBotPayload | undefined => {
  return message?.payload?.content?.case === 'botPayload'
    ? message.payload?.content.value
    : undefined
}

export const isGptBotPayload = (message?: IMessage): boolean => {
  if (!message) {
    return false
  }

  const botPayload = getBotPayload(message)

  return botPayload?.option?.case === 'gpt'
}

export const getGptConfig = (
  message: IMessage
): IGptConfigDataResponse | undefined => {
  const botPayload = getBotPayload(message)

  return botPayload?.option.case === 'gpt'
    ? botPayload?.option?.value?.configDataResponse
    : undefined
}
